import dealTransformer from '../../../stock/service/dealTransformer';
import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';
import { useCallback } from 'react';
import useGetPostCode from '../../../common/react/useGetPostCode';
import useWidgetContext from '../../../common/react/useWidgetContext';
import { useParams } from 'react-router';
import useSelectedAccessories from './useSelectedAccessories';
import urlRoute from '../../../common/service/urlRoute';
import IParams from '../../../gqlCustomise/model/IParams';
import useCustomerStorage from '../../../common/hooks/useCustomerStorage';

const useBuildDealAccessoriesPayload = (route: string) => {
  const postcode = useGetPostCode();
  const { modelId, carId, externalId } = useParams<IParams>();
  const { customerStorage } = useCustomerStorage();
  const dealerId = customerStorage.getCustomerData()?.dealerId || '';
  const {
    configuration: { basePath },
  } = useWidgetContext();
  const car = useSelector(carConfigurationSelectors.getCustomisedCar);
  const { setAndReturnAccessories } = useSelectedAccessories();
  const currentUrl = urlRoute.createUrl(route, { modelId, carId, externalId });

  const buildDealAccessoriesPayload = useCallback(
    (option: string) => {
      const accessories = setAndReturnAccessories(option);
      const partialPayload = dealTransformer.processDealAccessoriesPayload(car, accessories, postcode, dealerId);
      const payload = dealTransformer.addConfigurationSourceUrl(partialPayload, basePath, modelId, car, currentUrl);

      return payload;
    },
    [car, dealerId, modelId, basePath, setAndReturnAccessories],
  );

  return { buildDealAccessoriesPayload };
};

export default useBuildDealAccessoriesPayload;
